import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ isDisabled }) => (isDisabled ? '#cecece' : '#c6eafb')};
  border-radius: 100px;
  padding: 5px 20px;
  width: 100%;
  height: 50px;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  input {
    flex: 1;
    background: transparent;
    border: 0;
    color: #243342;
    outline: 0;
    font-family: Lato, sans-serif;

    &::placeholder {
      color: #8b99a7;
    }
  }
`;

export const ContainerLabel = styled.div`
  margin-right: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;
